import './_styles.scss';
import React from 'react';
import Content from './_content';
import Copyright from "./_copyright";

export default () => (
  <section className='Footer'>

    <Content/>

    <Copyright/>

  </section>
)
